// extracted by mini-css-extract-plugin
export var paginationCurrent = "index-module--pagination-current--a9fc9";
export var thumbsSwiper = "index-module--thumbs-swiper--0feea";